import { Link, LinkProps, makeStyles } from '@material-ui/core';
import React from 'react';

export type AnchorProps = LinkProps & {
}

export function Anchor (props: AnchorProps) {
    const cls = useStyles();

    return <Link {...props} classes={{
        ...props.classes,
        root: cls.root
    }} />
}

const useStyles = makeStyles(theme => ({
    root: {
        cursor: 'pointer'
    }
}));